import styled from "styled-components";

export const Outer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-self: flex-start;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #9d174d;
  background: #fce7f3;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.02em;
`;

export const TabRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 4px;
`;

export const Tab = styled.button<{ $active: boolean }>`
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$active ? "#111827" : "#e5e7eb")};
  background: ${(p) => (p.$active ? "#111827" : "#ffffff")};
  color: ${(p) => (p.$active ? "#ffffff" : "#374151")};
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    opacity: 0.92;
  }
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionHeading = styled.h2`
  margin: 0;
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  color: #111827;
`;

export const CoverageListGrid = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  column-gap: 12px;
  row-gap: 14px;
  align-items: start;
  width: 100%;
`;

export const CoverageSectionTitle = styled.h2`
  grid-column: 1 / -1;
  margin: 0;
  box-sizing: border-box;
  text-align: left;
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  color: #111827;
`;

export const CoverageListRow = styled.div`
  display: contents;
`;

export const CoverageIconCell = styled.div`
  width: 40px;
  min-width: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Subheading = styled.h3`
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #111827;
`;

export const MutedCard = styled.div`
  background: #f9fafb;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border: 1px solid #f3f4f6;
`;

export const RepairIconWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #ede9fe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MutedText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  color: #4b5563;
`;

export const GaugeTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GaugeRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const GaugeCol = styled.div<{ $highlight?: boolean }>`
  flex: 1;
  border-radius: 12px;
  padding: 12px 8px 16px;
  background: ${(p) => (p.$highlight ? "#f5f3ff" : "#f9fafb")};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: 1px solid ${(p) => (p.$highlight ? "#ddd6fe" : "#f3f4f6")};
`;

export const GaugeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const GaugeCell = styled.div<{ $highlight?: boolean }>`
  border-radius: 12px;
  padding: 12px 8px 16px;
  background: ${(p) => (p.$highlight ? "#ede9fe" : "#f9fafb")};
  border: 1px solid ${(p) => (p.$highlight ? "#c4b5fd" : "#f3f4f6")};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const GaugeBadge = styled.div`
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  color: #111827;
`;

export const GaugeFoot = styled.div`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #4b5563;
`;

export const SemicircleWrap = styled.div`
  width: 100%;
  max-width: 120px;
  margin: 0 auto;
`;

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const TimelineItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding-bottom: 18px;
  position: relative;

  &:not(:last-child)::before {
    content: "";
    position: absolute;
    left: 11px;
    top: 28px;
    bottom: 0;
    width: 2px;
    background: #e9d5ff;
  }
`;

export const TimelineDot = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #a78bfa;
  flex-shrink: 0;
`;

export const TimelineBody = styled.div`
  flex: 1;
`;

export const TimelineTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #111827;
`;

export const TimelineSubtitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #7c3aed;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TimelineDesc = styled.div`
  font-size: 14px;
  color: #4b5563;
  margin-top: 6px;
  line-height: 21px;
`;

export const BannerNote = styled.div`
  background: #f5f3ff;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  color: #5b21b6;
  text-align: center;
`;

export const GuideScroll = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const GuideCard = styled.div`
  min-width: 260px;
  scroll-snap-align: start;
  background: #faf5ff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #ede9fe;
`;

export const GuideCardIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #ede9fe;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 18px;
`;

export const GuideCardTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
`;

export const GuideCardBody = styled.div`
  font-size: 13px;
  line-height: 20px;
  color: #4b5563;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const StatCard = styled.div`
  background: #fafafa;
  border-radius: 12px;
  padding: 14px;
  border: 1px solid #f3f4f6;
`;

export const StatIcon = styled.div`
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  min-height: 22px;
`;

export const StatValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #111827;
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 16px;
`;

/** Matches network_garage_list_node `garages_page_heading` + `location_container`. */
export const GaragesSectionHeading = styled.h2`
  margin: 0;
  padding-bottom: 24px;
  color: var(--Neutral-N600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
`;

export const LocationPinRow = styled.button`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  margin: 0;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #efe9fb;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #fafafa;
  }
`;

export const LocationIconWrap = styled.span`
  display: flex;
  flex-shrink: 0;
  padding-right: 4px;
`;

export const PincodeDisplayText = styled.span`
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`;

export const LocationChevronWrap = styled.span`
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
`;
